import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withModifiers as _withModifiers, unref as _unref, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "contenedor-tabla" }
const _hoisted_2 = { class: "filtro-botones" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "filtro-select"
}
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "filtros-secundarios" }
const _hoisted_7 = { class: "filtro-grupo" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "filtro-grupo" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "filtro-grupo" }
const _hoisted_12 = {
  key: 0,
  class: "filtro-grupo"
}
const _hoisted_13 = { class: "toggle-label" }
const _hoisted_14 = {
  key: 1,
  class: "loading"
}
const _hoisted_15 = {
  key: 2,
  class: "cards-grid"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "estado-badge" }
const _hoisted_18 = { class: "card-titulo" }
const _hoisted_19 = { class: "card-info" }
const _hoisted_20 = {
  key: 0,
  class: "card-info"
}
const _hoisted_21 = {
  key: 1,
  class: "card-info"
}
const _hoisted_22 = { class: "card-info" }
const _hoisted_23 = {
  key: 2,
  class: "card-acciones"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick", "disabled"]
const _hoisted_26 = ["onClick", "disabled"]
const _hoisted_27 = ["disabled", "onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "estado-badge" }
const _hoisted_30 = { class: "card-titulo" }
const _hoisted_31 = { class: "card-info" }
const _hoisted_32 = { class: "card-info" }
const _hoisted_33 = {
  key: 0,
  class: "badge-proceso-activo"
}
const _hoisted_34 = {
  key: 1,
  class: "card-acciones"
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["disabled", "onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["disabled", "onClick"]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["disabled", "onClick"]
const _hoisted_47 = {
  key: 3,
  class: "paginacion"
}
const _hoisted_48 = ["disabled"]
const _hoisted_49 = { class: "pag-info" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = {
  key: 4,
  class: "error"
}
const _hoisted_52 = { key: 5 }
const _hoisted_53 = { class: "ev-panel" }
const _hoisted_54 = {
  key: 0,
  class: "dc-objetivo"
}
const _hoisted_55 = { class: "ev-campo" }
const _hoisted_56 = { class: "ev-botones" }
const _hoisted_57 = ["disabled"]
const _hoisted_58 = { class: "ev-panel" }
const _hoisted_59 = { class: "ev-campo" }
const _hoisted_60 = { class: "ev-botones" }
const _hoisted_61 = ["disabled"]
const _hoisted_62 = ["disabled"]

import { ref, onMounted, computed, watch } from 'vue'
import { useRouter } from 'vue-router'
import useAutenticar from '@/store/IngresoAutenticar'
import { useAsignacionActual } from '@/composables/useAsignacionActual'
import useModelo from '@/store/GestionModelo'
import { useGestionVersiones } from '@/store/GestionVersiones'
import { useGestionTipoModelos } from '@/store/GestionTipoModelo'
import { useGestionProgramas } from '@/store/GestionPrograma'
import { useGestionCampus } from '@/store/GestionCampus'
import { useGestionProcesos } from '@/store/GestionProcesoAutoevaluacion'
import type EstructuraModelo from '@/interfaces/EstructuraModelo'
import type Version from '@/interfaces/Versiones'
import type { Programa } from '@/interfaces/Programa'
import LoadingOverlay from '@/components/LoadingOverlay.vue' 
import MensajeFlotante from '@/components/MensajeFlotante.vue'
import ClonarModeloModal from '@/components/ClonarModeloModal.vue'
import VersionarModal from '@/components/VersionarModal.vue'

interface ModeloConVersiones extends EstructuraModelo {
  versions: Version[]
}

interface VersionExtendida extends Version {
  modeloNombre: string
  id_tipo_modelo: number
  modeloEstado: string
}

const ITEMS_POR_PAGINA = 9
type DescontinuarPendiente = { tipo: 'modelo'; id: number } | { tipo: 'version'; v: VersionExtendida }

export default /*@__PURE__*/_defineComponent({
  __name: 'ListaModelos',
  props: {
    modoIndicadores: { type: Boolean },
    modoCalificar: { type: Boolean },
    modoEvidencias: { type: Boolean },
    modoAsignarEvaluadores: { type: Boolean },
    modoEvaluacionExpertos: { type: Boolean }
  },
  setup(__props: any) {

/**
 * Listado de modelos con su estado y acciones.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const props = __props
const auth = useAutenticar()
const { necesitaFiltro, idsVersiones, tieneAsignacionProceso } = useAsignacionActual()
const clonando = ref<number | null>(null)
const clonarEnProceso = ref(false) 
const descontinuando = ref(false) 
const cardSeleccionada = ref<number | null>(null)
const router = useRouter()
const modeloStore = useModelo()
const tipoModeloStore = useGestionTipoModelos()
const programaStore = useGestionProgramas()
const campusStore = useGestionCampus()
const procesosStore = useGestionProcesos()

// Set de id_version que tienen al menos un proceso activo (no finalizado)
const versionesConProceso = ref<Set<number>>(new Set())
// Set de id_version que están en al menos un proceso Y todos son finalizado
const versionesTodosFinalizados = ref<Set<number>>(new Set())
// Mapa id_version → estado e id del proceso activo
const versionesEstadoProceso = ref<Record<number, string>>({})
const versionesIdProceso     = ref<Record<number, number>>({})
const completandoEtapa = ref(false)
const modelos = ref<ModeloConVersiones[]>([])
const loading = ref(false)
const error = ref<string | null>(null)
const versionesStore = useGestionVersiones()

// Modal clonar modelo
const modalClonarVisible = ref(false)
const versionParaClonar = ref<VersionExtendida | null>(null)
const modeloParaClonar = ref<ModeloConVersiones | null>(null)

// Modal versionar
const modalVersionarVisible = ref(false)
const versionParaVersionar = ref<VersionExtendida | null>(null)
const modeloParaVersionar = ref<ModeloConVersiones | null>(null)
const versionando = ref<number | null>(null)

// Filtros
const filtroTipo = ref('')
const filtroPrograma = ref('')
const filtroEstado = ref('')
const filtroFecha = ref('')
const filtroBusqueda = ref('')

const mostrarVersionesProcesosActivos = ref(false)

const opcionesEstado = [
  { label: 'Completado', value: 'completado' },
  { label: 'Aprobado', value: 'aprobado' },
  { label: 'Edición', value: 'edicion' },
  { label: 'Descontinuado', value: 'descontinuado' }
]

const opcionesFechaFiltro = [
  { label: 'Hoy', value: 'hoy' },
  { label: 'Última semana', value: 'semana' },
  { label: 'Este mes', value: 'mes' }
]

const formatterFecha = new Intl.DateTimeFormat('es-CO', { day: '2-digit', month: '2-digit', year: 'numeric' })

// Función para parsear fechas correctamente (maneja formato YYYY-MM-DD del backend)
function parseFecha(fecha?: string | null): Date | null {
  if (!fecha) return null
  const soloFecha = fecha.substring(0, 10)
  if (/^\d{4}-\d{2}-\d{2}$/.test(soloFecha)) {
    const [yyyy, mm, dd] = soloFecha.split('-').map(Number)
    return new Date(yyyy, mm - 1, dd)
  }
  const d = new Date(fecha)
  return isNaN(d.getTime()) ? null : d
}

// Opciones de filtro únicas por nombre de tipo
const opcionesFiltro = computed(() => {
  const seen = new Set<string>()
  const result: { label: string; value: string }[] = [{ label: 'Todos', value: '' }]

  for (const t of tipoModeloStore.tipos) {
    if (!seen.has(t.tipo)) {
      seen.add(t.tipo)
      result.push({ label: t.tipo, value: t.tipo })
    }
  }

  return result
})

// Opciones de programas únicos desde el store de programas
const opcionesProgramas = computed(() => {
  return programaStore.programas.map(p => p.nombre)
})

// Filtrado solo por tipo y programa
const modelosFiltrados = computed(() => {
  let base = modelos.value

  if (filtroTipo.value) {
    base = base.filter(m => {
      const tipo = tipoModeloStore.tipos.find(t => t.id_tipo_modelo === m.id_tipo_modelo)
      return tipo?.tipo === filtroTipo.value
    })
  }

  if (filtroTipo.value === 'Programas' && filtroPrograma.value) {
    // id_programa ahora vive en la versión (C-03)
    base = base.filter(m =>
      (m.versions ?? []).some((v: any) => {
        const programa = programaStore.programas.find(p => p.id_programa === v.id_programa)
        return programa?.nombre === filtroPrograma.value
      })
    )
  }

  return base
})

const modoNormal = computed(() =>
  !props.modoIndicadores && !props.modoCalificar && !props.modoEvidencias &&
  !props.modoAsignarEvaluadores && !props.modoEvaluacionExpertos
)

const ordenEstadosModelo: Record<string, number> = { completado: 1, aprobado: 2, edicion: 3, descontinuado: 4 }

const modelosParaCardsNormal = computed<ModeloConVersiones[]>(() => {
  let base = modelosFiltrados.value

  if (filtroEstado.value) {
    base = base.filter(m => m.estado === filtroEstado.value)
  }

  if (filtroFecha.value) {
    const ahora = new Date()
    const hoy = new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate())
    base = base.filter(m => {
      const fecha = parseFecha(m.fecha_creacion)
      if (!fecha) return false
      if (filtroFecha.value === 'hoy') {
        const fechaSoloFecha = new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate())
        return fechaSoloFecha.getTime() === hoy.getTime()
      } else if (filtroFecha.value === 'semana') {
        const hace7 = new Date(hoy); hace7.setDate(hace7.getDate() - 7)
        return fecha >= hace7
      } else if (filtroFecha.value === 'mes') {
        return fecha >= new Date(ahora.getFullYear(), ahora.getMonth(), 1)
      }
      return true
    })
  }

  if (filtroBusqueda.value.trim()) {
    const termino = filtroBusqueda.value.trim().toLowerCase()
    base = base.filter(m => m.nombre?.toLowerCase().includes(termino))
  }

  return [...base].sort((a, b) => {
    const aDesc = a.estado === 'descontinuado' ? 1 : 0
    const bDesc = b.estado === 'descontinuado' ? 1 : 0
    if (aDesc !== bDesc) return aDesc - bDesc
    const fa = parseFecha(a.fecha_creacion)?.getTime() ?? 0
    const fb = parseFecha(b.fecha_creacion)?.getTime() ?? 0
    return fb - fa
  })
})

const modalClonarIdModelo = computed(() =>
  modeloParaClonar.value?.id_modelo ?? versionParaClonar.value?.id_modelo ?? null
)

const modalClonarIdVersionOrigen = computed<number | null>(() => {
  if (modeloParaClonar.value) {
    // Al clonar desde un modelo (sin versión explícita), el backend clona la
    // versión más reciente (mayor id_version). Filtramos el árbol por ESA misma
    // versión para no mezclar indicadores de otras versiones (duplicados).
    const versiones = modeloParaClonar.value.versions ?? []
    if (versiones.length === 0) return null
    return versiones.reduce((max, v) => ((v.id_version ?? 0) > (max.id_version ?? 0) ? v : max)).id_version ?? null
  }
  return versionParaClonar.value?.id_version ?? null
})

// Versiones aplanadas desde modelos filtrados con filtro por estado de versión
const versionesFiltradas = computed<VersionExtendida[]>(() => {
  const ordenEstados: Record<string, number> = {
    completado: 1,
    aprobado: 2,
    edicion: 3,
    descontinuado: 4
  }

  let resultado = modelosFiltrados.value
    .flatMap(m =>
      (m.versions ?? [])
        .filter(v => {
          if (props.modoIndicadores) {
            if (mostrarVersionesProcesosActivos.value) {
              return v.estado === 'edicion' || v.estado === 'aprobado'
            }
            if (v.estado === 'edicion') return !versionesConProceso.value.has(v.id_version!)
            if (versionesTodosFinalizados.value.has(v.id_version!)) return true
            return false
          } else if (props.modoCalificar) {
            return (v.estado === 'aprobado' || v.estado === 'edicion') && versionesEstadoProceso.value[v.id_version!] === 'evaluacion'
          } else if (props.modoEvidencias) {
            return (v.estado === 'aprobado' || v.estado === 'edicion') && versionesEstadoProceso.value[v.id_version!] === 'ejecucion'
          } else if (props.modoAsignarEvaluadores) {
            return (v.estado === 'aprobado' || v.estado === 'edicion') && versionesConProceso.value.has(v.id_version!)
          } else if (props.modoEvaluacionExpertos) {
            return (v.estado === 'aprobado' || v.estado === 'edicion') && versionesEstadoProceso.value[v.id_version!] === 'informe'
          } else {
            return true
          }
        })
        .map(v => ({
          ...v,
          modeloNombre: v.nombre,
          id_tipo_modelo: m.id_tipo_modelo,
          modeloEstado: m.estado ?? ''
          // id_programa ya viene en v desde la versión (C-03)
        }))
    )

  // Filtro por estado
  if (filtroEstado.value) {
    resultado = resultado.filter(v => v.estado === filtroEstado.value)
  }

  // Filtro por fecha
  if (filtroFecha.value) {
    const ahora = new Date()
    const hoy = new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate())
    resultado = resultado.filter(v => {
      const fecha = parseFecha(v.fecha_creacion)
      if (!fecha) return false
      
      if (filtroFecha.value === 'hoy') {
        // Comparar solo año, mes y día
        const fechaSoloFecha = new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate())
        return fechaSoloFecha.getTime() === hoy.getTime()
      } else if (filtroFecha.value === 'semana') {
        const hace7 = new Date(hoy)
        hace7.setDate(hace7.getDate() - 7)
        return fecha >= hace7
      } else if (filtroFecha.value === 'mes') {
        const inicioMes = new Date(ahora.getFullYear(), ahora.getMonth(), 1)
        return fecha >= inicioMes
      }
      return true
    })
  }

  // Filtro por búsqueda de nombre
  if (filtroBusqueda.value.trim()) {
    const termino = filtroBusqueda.value.trim().toLowerCase()
    resultado = resultado.filter(v => v.modeloNombre?.toLowerCase().includes(termino))
  }

  // Filtro por asignación de usuario
  if (props.modoEvidencias || props.modoCalificar || props.modoEvaluacionExpertos) {
    // En estos modos todos los no-admin solo ven sus procesos asignados,
    // independientemente de otros permisos (coordinadores, directores, etc.)
    if (!auth.esAdmin) {
      resultado = resultado.filter(v => {
        const idProceso = versionesIdProceso.value[v.id_version!]
        return idProceso != null && tieneAsignacionProceso(v.id_version!, idProceso)
      })
    }
  } else if (necesitaFiltro.value) {
    // Otros modos: filtro por versión para usuarios sin permisos amplios
    resultado = idsVersiones.value.length > 0
      ? resultado.filter(v => idsVersiones.value.includes(v.id_version!))
      : []
  }

  return resultado.sort((a, b) => {
    if (props.modoIndicadores) {
      const prioV = (e?: string) => e === 'edicion' ? 0 : e === 'descontinuado' ? 2 : 1
      const diff = prioV(a.estado) - prioV(b.estado)
      if (diff !== 0) return diff
    } else {
      const aDesc = a.modeloEstado === 'descontinuado' ? 1 : 0
      const bDesc = b.modeloEstado === 'descontinuado' ? 1 : 0
      if (aDesc !== bDesc) return aDesc - bDesc
    }
    const fechaA = parseFecha(a.fecha_creacion)?.getTime() ?? 0
    const fechaB = parseFecha(b.fecha_creacion)?.getTime() ?? 0
    return fechaB - fechaA
  })
})

const mensajeVisible = ref(false)
const mensajeTexto = ref('')
const mensajeTipo = ref<'positivo' | 'error'>('positivo')

// ── Paginación ──────────────────────────────────────────────
const paginaActual = ref(1)

const totalPaginas = computed(() => {
  const total = modoNormal.value ? modelosParaCardsNormal.value.length : versionesFiltradas.value.length
  return Math.max(1, Math.ceil(total / ITEMS_POR_PAGINA))
})

const modelosPaginados = computed<ModeloConVersiones[]>(() => {
  const inicio = (paginaActual.value - 1) * ITEMS_POR_PAGINA
  return modelosParaCardsNormal.value.slice(inicio, inicio + ITEMS_POR_PAGINA)
})

const versionesPaginadas = computed<VersionExtendida[]>(() => {
  const inicio = (paginaActual.value - 1) * ITEMS_POR_PAGINA
  return versionesFiltradas.value.slice(inicio, inicio + ITEMS_POR_PAGINA)
})

watch(
  [filtroTipo, filtroPrograma, filtroEstado, filtroFecha, filtroBusqueda, mostrarVersionesProcesosActivos],
  () => { paginaActual.value = 1 }
)

function mostrarMensaje(texto: string, tipo: 'positivo' | 'error') {
  mensajeTexto.value = texto
  mensajeTipo.value = tipo
  mensajeVisible.value = true
}

// ── Editar nombre de versión ────────────────────────────────
const editarVersionVisible = ref(false)
const versionAEditar = ref<VersionExtendida | null>(null)
const nombreEdicion = ref('')
const guardandoEdicion = ref(false)

function abrirEditarVersion(v: VersionExtendida) {
  versionAEditar.value = v
  nombreEdicion.value = v.nombre ?? ''
  editarVersionVisible.value = true
}

async function guardarEdicionVersion() {
  const v = versionAEditar.value
  if (!v?.id_version || !nombreEdicion.value.trim() || guardandoEdicion.value) return
  guardandoEdicion.value = true
  try {
    const ok = await versionesStore.updateVersion({ ...v, nombre: nombreEdicion.value.trim() })
    if (ok) {
      mostrarMensaje('Nombre actualizado correctamente.', 'positivo')
      editarVersionVisible.value = false
      versionAEditar.value = null
      await cargar()
    } else {
      mostrarMensaje('No se pudo actualizar el nombre.', 'error')
    }
  } finally {
    guardandoEdicion.value = false
  }
}

function formatFecha(fecha?: string | null) {
  if (!fecha) return '-'
  const soloFecha = fecha.substring(0, 10)
  if (/^\d{4}-\d{2}-\d{2}$/.test(soloFecha)) {
    const [yyyy, mm, dd] = soloFecha.split('-').map(Number)
    const d = new Date(yyyy, mm - 1, dd)
    return formatterFecha.format(d)
  }
  const d = new Date(fecha)
  return isNaN(d.getTime()) ? fecha : formatterFecha.format(d)
}

const ETIQUETAS_ESTADO_PROCESO: Record<string, string> = {
  preparacion: 'Preparación',
  ejecucion: 'Ejecución',
  evaluacion: 'Evaluación',
  informe: 'Informe',
  finalizado: 'Finalizado'
}
function etiquetaEstadoProceso(estado?: string): string {
  return ETIQUETAS_ESTADO_PROCESO[estado ?? ''] ?? estado ?? 'Activo'
}

function estadoClass(estado?: string | null) {
  switch (estado) {
    case 'aprobado': return 'estado-aprobado'
    case 'descontinuado': return 'estado-descontinuado'
    case 'completado': return 'estado-completado'
    default: return 'estado-modificar'
  }
}

function tipoDeModelo(v: VersionExtendida) {
  return tipoModeloStore.tipos.find(t => t.id_tipo_modelo === v.id_tipo_modelo) ?? null
}

function tipoDeModeloById(idTipo?: number | null) {
  if (!idTipo) return null
  return tipoModeloStore.tipos.find(t => t.id_tipo_modelo === idTipo) ?? null
}

function versionActivaDeModelo(m: ModeloConVersiones): Version | null {
  return (m.versions ?? []).find(vv => vv.estado !== 'descontinuado') ?? null
}

function accederModelo(m: ModeloConVersiones) {
  if (!m.id_modelo) return

  if (m.estado === 'edicion') {
    router.push({ name: 'EstructuraModelo', params: { id_modelo: m.id_modelo } })
    return
  }

  const activa = versionActivaDeModelo(m)

  if (!activa) {
    // Modelo descontinuado: muestra árbol de componentes y pesos, sin requerir versión.
    router.push({ name: 'PresentarDocumento', params: { id_modelo: m.id_modelo, id_version: 0 } })
    return
  }

  if (activa.estado === 'aprobado') {
    router.push({ name: 'PresentarDocumento', params: { id_modelo: m.id_modelo, id_version: activa.id_version } })
  } else if (activa.estado === 'completado') {
    router.push({ name: 'ModeloCompleto', params: { id_modelo: m.id_modelo, id_version: activa.id_version } })
  }
}

function abrirModalVersionarModelo(m: ModeloConVersiones) {
  if (versionando.value !== null) return
  modeloParaVersionar.value = m
  versionParaVersionar.value = null
  modalVersionarVisible.value = true
}

function abrirModalClonarModelo(m: ModeloConVersiones) {
  if (!m.id_modelo || clonando.value !== null) return
  modeloParaClonar.value = m
  versionParaClonar.value = null
  modalClonarVisible.value = true
}

function toggleCard(id: number) {
  cardSeleccionada.value = cardSeleccionada.value === id ? null : id
}

async function cargar() {
  loading.value = true
  error.value = null
  try {
    const tareas: Promise<any>[] = [
      modeloStore.getModelo().then(m => { modelos.value = m as ModeloConVersiones[] }),
      tipoModeloStore.getTipoModelos(),
      programaStore.cargarTodos(),
      campusStore.cargarTodos()
    ]

    if (!modoNormal.value) {
      tareas.push(
        procesosStore.cargarTodos().then(() => {
          const todos = procesosStore.procesos
          const activos = todos.filter(p => p.estado !== 'finalizado')
          versionesConProceso.value = new Set(activos.map(p => p.id_version).filter((id): id is number => id != null))

          const todasVersionesEnProceso = new Set(todos.map(p => p.id_version).filter((id): id is number => id != null))
          const finalizados = new Set<number>()
          for (const idV of todasVersionesEnProceso) {
            if (todos.filter(p => p.id_version === idV).every(p => p.estado === 'finalizado')) {
              finalizados.add(idV)
            }
          }
          versionesTodosFinalizados.value = finalizados
          const estadoMap: Record<number, string> = {}
          const idMap: Record<number, number> = {}
          for (const p of activos) {
            estadoMap[p.id_version] = p.estado ?? ''
            idMap[p.id_version] = p.id!
          }
          versionesEstadoProceso.value = estadoMap
          versionesIdProceso.value = idMap
        })
      )
    }

    await Promise.all(tareas)
  } catch (err: any) {
    error.value = err?.message || 'Error desconocido'
  } finally {
    loading.value = false
  }
}

// Navegación de los botones
function accederVersion(v: VersionExtendida) {
  if (!v.id_modelo || !v.id_version) return
  if (v.estado === 'aprobado') {
    router.push({ name: 'PresentarDocumento', params: { id_modelo: v.id_modelo, id_version: v.id_version } })
  } else if (v.estado === 'completado') {
    router.push({ name: 'ModeloCompleto', params: { id_modelo: v.id_modelo, id_version: v.id_version } })
  } else {
    router.push({ name: 'EstructuraModelo', params: { id_modelo: v.id_modelo, id_version: v.id_version } })
  }
}

function agregarIndicadoresVersion(v: VersionExtendida) {
  if (!v.id_version) return
  router.push({ name: 'AgregarIndicadores', params: { id_version: v.id_version } })
}

function calificarInstrumentosVersion(v: VersionExtendida) {
  if (!v.id_version) return
  router.push({ name: 'ListaCalificar', params: { id_version: v.id_version } })
}

function subirEvidenciasVersion(v: VersionExtendida) {
  if (!v.id_version) return
  router.push({ name: 'EvidenciasInstrumentos', params: { id_version: v.id_version } })
}

function navegarEvaluacionExpertos(v: VersionExtendida, routeName: string) {
  if (!v.id_version) return
  router.push({ name: routeName, params: { id_version: v.id_version } })
}

//clonar versiones
async function clonarVersion(v: VersionExtendida) {
  if (!v.id_version) return
  if (clonando.value !== null) return

  clonando.value = v.id_version
  try {
    const nuevaVersion = await versionesStore.clonarVersion(v.id_version)
    if (!nuevaVersion) {
      mostrarMensaje('No se pudo clonar la versión', 'error')
      return
    }

    mostrarMensaje(`Versión clonada correctamente: ${nuevaVersion.nombre}`, 'positivo')

    await cargar()
  } catch (err) {
    console.error('Error al clonar versión:', err)
    mostrarMensaje('Ocurrió un error al clonar la versión', 'error')
  } finally {
    clonando.value = null
  }
}

function abrirModalVersionar(v: VersionExtendida) {
  if (!v.id_version || versionando.value !== null) return
  versionParaVersionar.value = v
  modalVersionarVisible.value = true
}

async function confirmarVersionar(payload: { nuevoNombre?: string; enfoque?: string }) {
  modalVersionarVisible.value = false

  const nuevoNombre = payload.nuevoNombre
  // Enfoque elegido para la nueva versión ('general' = sin filtro, se omite).
  const enfoque = payload.enfoque && payload.enfoque !== 'general' ? payload.enfoque : undefined

  const m = modeloParaVersionar.value
  const v = versionParaVersionar.value

  if (m) {
    const idModelo = m.id_modelo!
    versionando.value = idModelo
    try {
      const nueva = await versionesStore.crearVersion({
        id_modelo:        idModelo,
        nombre:           nuevoNombre ?? m.nombre,
        estado:           'edicion',
        fecha_creacion:   new Date().toISOString().split('T')[0],
        fecha_aprobacion: null,
        ambito:           null,
        id_programa:      null,
        enfoque:          enfoque ?? null
      })
      if (!nueva) { mostrarMensaje('No se pudo crear la nueva versión.', 'error'); return }
      mostrarMensaje(`Versión creada: ${nueva.nombre}`, 'positivo')
      await cargar()
      router.push({ name: 'ListaVersiones', query: { modo: 'indicadores' } })
    } finally {
      modeloParaVersionar.value = null
      versionando.value = null
    }
  } else if (v?.id_version) {
    versionando.value = v.id_version
    try {
      const nueva = await versionesStore.clonarVersion(v.id_version, nuevoNombre, undefined, enfoque)
      if (!nueva) { mostrarMensaje('No se pudo crear la nueva versión.', 'error'); return }
      mostrarMensaje(`Nueva versión creada: ${nueva.nombre}`, 'positivo')
      await cargar()
      router.push({ name: 'ListaVersiones', query: { modo: 'indicadores' } })
    } finally {
      versionParaVersionar.value = null
      versionando.value = null
    }
  }
}

// Abrir modal de clonación — siempre clona el modelo (no la versión)
function abrirModalClonar(v: VersionExtendida) {
  if (!v.id_modelo || !v.id_version || clonando.value !== null) return
  versionParaClonar.value = v
  modalClonarVisible.value = true
}

async function confirmarClonarModelo(payload: { opcion: string; ordinales?: string[]; nuevoNombre?: string }) {
  if (clonarEnProceso.value) {
    console.warn('Clonación ya en proceso, ignorando evento')
    return
  }

  clonarEnProceso.value = true
  modalClonarVisible.value = false

  const idModelo = modeloParaClonar.value?.id_modelo ?? versionParaClonar.value?.id_modelo
  if (!idModelo) {
    clonarEnProceso.value = false
    return
  }

  try {
    const ordinales = payload.opcion === 'seleccion' && (payload.ordinales?.length ?? 0) > 0
      ? payload.ordinales
      : undefined
    await ejecutarClonarModelo(idModelo, ordinales, payload.nuevoNombre)
  } finally {
    modeloParaClonar.value = null
    versionParaClonar.value = null
    clonarEnProceso.value = false
  }
}

// C-07: clonar modelo, opcionalmente con filtro de ordinales para clonación parcial.
// El clon copia SOLO la estructura: no nace con versión ni hereda indicadores.
async function ejecutarClonarModelo(id_modelo: number, ordinales?: string[], nuevoNombre?: string) {
  clonando.value = id_modelo as any
  const payload = {
    ...(ordinales?.length ? { ordinales } : {}),
    ...(nuevoNombre ? { nuevo_nombre: nuevoNombre } : {})
  }
  try {
    const clonado = await modeloStore.clonarModelo(id_modelo, payload)
    if (!clonado) {
      mostrarMensaje('No se pudo clonar el modelo', 'error')
      return
    }
    mostrarMensaje(`Modelo clonado correctamente: ${clonado.nombre}`, 'positivo')
    await cargar()
  } catch (err) {
    console.error('Error al clonar modelo:', err)
    mostrarMensaje('Ocurrió un error al clonar el modelo', 'error')
  } finally {
    clonando.value = null
  }
}

// ── Confirmación descontinuar ───────────────────────────────
const confirmarDescontinuarVisible = ref(false)
const confirmarDescontinuarTexto = ref('')
const confirmarDescontinuarNombre = ref('')
let _descontinuarPendiente: DescontinuarPendiente | null = null

function abrirConfirmarDescontinuarModelo(m: { id_modelo?: number; nombre?: string }) {
  if (!m.id_modelo) return
  _descontinuarPendiente = { tipo: 'modelo', id: m.id_modelo }
  confirmarDescontinuarNombre.value = m.nombre ?? ''
  confirmarDescontinuarTexto.value = ''
  confirmarDescontinuarVisible.value = true
}

function abrirConfirmarDescontinuarVersion(v: VersionExtendida) {
  if (!v.id_version) return
  _descontinuarPendiente = { tipo: 'version', v }
  confirmarDescontinuarNombre.value = v.nombre ?? ''
  confirmarDescontinuarTexto.value = ''
  confirmarDescontinuarVisible.value = true
}

function cerrarConfirmarDescontinuar() {
  confirmarDescontinuarVisible.value = false
  confirmarDescontinuarTexto.value = ''
  _descontinuarPendiente = null
}

async function ejecutarDescontinuar() {
  if (confirmarDescontinuarTexto.value.trim().toLowerCase() !== 'descontinuar') return
  if (!_descontinuarPendiente) return
  const pendiente = _descontinuarPendiente
  cerrarConfirmarDescontinuar()
  if (pendiente.tipo === 'modelo') {
    await descontinuarModelo(pendiente.id)
  } else {
    await descontinuarVersion(pendiente.v)
  }
}

async function descontinuarModelo(id_modelo?: number) {
  if (!id_modelo) return
  descontinuando.value = true
  try {
    const result = await modeloStore.descontinuarModelo(id_modelo)
    if (result.ok) {
      mostrarMensaje('El modelo fue descontinuado correctamente.', 'positivo')
      await cargar()
    } else {
      mostrarMensaje(result.message ?? 'No se pudo descontinuar el modelo.', 'error')
    }
  } finally {
    descontinuando.value = false
  }
}

async function descontinuarVersion(v: VersionExtendida): Promise<void> {
  if (!v.id_version) return
  descontinuando.value = true
  try {
    const ok = await versionesStore.cambiarEstadoVersion(v.id_version, 'descontinuado')
    if (ok) {
      mostrarMensaje('Versión descontinuada correctamente.', 'positivo')
      await cargar()
    } else {
      mostrarMensaje('No se pudo descontinuar la versión.', 'error')
    }
  } catch {
    mostrarMensaje('Error al descontinuar la versión.', 'error')
  } finally {
    descontinuando.value = false
  }
}

async function completarEtapa(v: VersionExtendida) {
  const idProceso = versionesIdProceso.value[v.id_version!]
  if (!idProceso) {
    mostrarMensaje('No se encontró el proceso asociado a esta versión.', 'error')
    return
  }
  const nuevoEstado = props.modoEvidencias ? 'evaluacion' : 'informe'
  completandoEtapa.value = true
  try {
    const result = await procesosStore.cambiarEstado(idProceso, nuevoEstado as any)
    if (result.ok) {
      mostrarMensaje('Etapa completada correctamente.', 'positivo')
      cardSeleccionada.value = null
      await cargar()
    } else {
      mostrarMensaje('No se pudo completar la etapa.', 'error')
    }
  } finally {
    completandoEtapa.value = false
  }
}

onMounted(cargar)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LoadingOverlay, {
      visible: clonando.value !== null || descontinuando.value || completandoEtapa.value || (props.modoEvidencias && loading.value),
      message: clonando.value !== null ? 'Clonando modelo...' : descontinuando.value ? 'Descontinuando versión...' : completandoEtapa.value ? 'Completando etapa...' : 'Cargando modelos...'
    }, null, 8, ["visible", "message"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opcionesFiltro.value, (t) => {
        return (_openBlock(), _createElementBlock("button", {
          key: t.label,
          class: _normalizeClass(['btn-filtro', filtroTipo.value === t.value ? 'activo' : '']),
          onClick: ($event: any) => {filtroTipo.value = t.value; filtroPrograma.value = ''; filtroEstado.value = ''; filtroFecha.value = ''; filtroBusqueda.value = ''}
        }, _toDisplayString(t.label), 11, _hoisted_3))
      }), 128))
    ]),
    (filtroTipo.value === 'Programas')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[15] || (_cache[15] = _createElementVNode("label", { for: "programaSelect" }, "Programa:", -1)),
          _withDirectives(_createElementVNode("select", {
            id: "programaSelect",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filtroPrograma).value = $event)),
            class: "form-control"
          }, [
            _cache[14] || (_cache[14] = _createElementVNode("option", { value: "" }, "Todos", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opcionesProgramas.value, (p) => {
              return (_openBlock(), _createElementBlock("option", {
                key: p,
                value: p
              }, _toDisplayString(p), 9, _hoisted_5))
            }), 128))
          ], 512), [
            [_vModelSelect, filtroPrograma.value]
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _cache[17] || (_cache[17] = _createElementVNode("label", {
          class: "filtro-label",
          for: "filtroEstado"
        }, "Estado:", -1)),
        _withDirectives(_createElementVNode("select", {
          id: "filtroEstado",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filtroEstado).value = $event)),
          class: "select-filtro"
        }, [
          _cache[16] || (_cache[16] = _createElementVNode("option", { value: "" }, "Todos", -1)),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(opcionesEstado, (e) => {
            return _createElementVNode("option", {
              key: e.value,
              value: e.value
            }, _toDisplayString(e.label), 9, _hoisted_8)
          }), 64))
        ], 512), [
          [_vModelSelect, filtroEstado.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[19] || (_cache[19] = _createElementVNode("label", {
          class: "filtro-label",
          for: "filtroFecha"
        }, "Fecha:", -1)),
        _withDirectives(_createElementVNode("select", {
          id: "filtroFecha",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filtroFecha).value = $event)),
          class: "select-filtro"
        }, [
          _cache[18] || (_cache[18] = _createElementVNode("option", { value: "" }, "Todas", -1)),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(opcionesFechaFiltro, (f) => {
            return _createElementVNode("option", {
              key: f.value,
              value: f.value
            }, _toDisplayString(f.label), 9, _hoisted_10)
          }), 64))
        ], 512), [
          [_vModelSelect, filtroFecha.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[20] || (_cache[20] = _createElementVNode("span", { class: "filtro-label" }, "Buscar:", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filtroBusqueda).value = $event)),
          placeholder: "Nombre del modelo...",
          class: "input-busqueda"
        }, null, 512), [
          [_vModelText, filtroBusqueda.value]
        ])
      ]),
      (props.modoIndicadores)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("label", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((mostrarVersionesProcesosActivos).value = $event)),
                class: "toggle-check"
              }, null, 512), [
                [_vModelCheckbox, mostrarVersionesProcesosActivos.value]
              ]),
              _cache[21] || (_cache[21] = _createTextVNode(" Mostrar versiones en proceso activo "))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (loading.value && !props.modoEvidencias)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Cargando modelos..."))
      : _createCommentVNode("", true),
    (!loading.value && (modoNormal.value ? modelosParaCardsNormal.value.length > 0 : versionesFiltradas.value.length > 0))
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          (modoNormal.value)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(modelosPaginados.value, (m) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: m.id_modelo,
                  class: _normalizeClass(['modelo-card', cardSeleccionada.value === m.id_modelo ? 'card-activa' : '']),
                  onClick: ($event: any) => (toggleCard(m.id_modelo!))
                }, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", {
                      class: _normalizeClass(['estado', estadoClass(m.estado)])
                    }, _toDisplayString(m.estado), 3)
                  ]),
                  _createElementVNode("h3", _hoisted_18, _toDisplayString(m.nombre), 1),
                  _createElementVNode("p", _hoisted_19, "Fecha: " + _toDisplayString(formatFecha(m.fecha_creacion)), 1),
                  (m.vigencia)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_20, "Vigencia: " + _toDisplayString(m.vigencia), 1))
                    : _createCommentVNode("", true),
                  (m.acuerdo)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(m.acuerdo), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_22, "Tipo: " + _toDisplayString(tipoDeModeloById(m.id_tipo_modelo)?.tipo ?? 'Sin tipo'), 1),
                  (cardSeleccionada.value === m.id_modelo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("button", {
                          class: "btn guardar",
                          onClick: _withModifiers(($event: any) => (accederModelo(m)), ["stop"])
                        }, "Acceder", 8, _hoisted_24),
                        (_unref(auth).tienePermiso('versiones.crear'))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn guardar",
                              onClick: _withModifiers(($event: any) => (abrirModalVersionarModelo(m)), ["stop"]),
                              disabled: versionando.value !== null
                            }, _toDisplayString(versionando.value !== null ? 'Versionando...' : 'Versionar'), 9, _hoisted_25))
                          : _createCommentVNode("", true),
                        (_unref(auth).tienePermiso('modelos.crear'))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "btn guardar",
                              onClick: _withModifiers(($event: any) => (abrirModalClonarModelo(m)), ["stop"]),
                              disabled: clonando.value !== null
                            }, _toDisplayString(clonando.value !== null ? 'Clonando...' : 'Clonar'), 9, _hoisted_26))
                          : _createCommentVNode("", true),
                        (_unref(auth).tienePermiso('versiones.aprobar'))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              class: "btn peligro",
                              disabled: descontinuando.value,
                              onClick: _withModifiers(($event: any) => (abrirConfirmarDescontinuarModelo(m)), ["stop"])
                            }, "Descontinuar", 8, _hoisted_27))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_16))
              }), 128))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(versionesPaginadas.value, (v) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: v.id_version,
                  class: _normalizeClass(['modelo-card', cardSeleccionada.value === v.id_version ? 'card-activa' : '']),
                  onClick: ($event: any) => (toggleCard(v.id_version!))
                }, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("span", {
                      class: _normalizeClass(['estado', estadoClass(props.modoIndicadores ? v.estado : v.modeloEstado)])
                    }, _toDisplayString(props.modoIndicadores ? v.estado : v.modeloEstado), 3)
                  ]),
                  _createElementVNode("h3", _hoisted_30, _toDisplayString(v.modeloNombre), 1),
                  _createElementVNode("p", _hoisted_31, "Fecha: " + _toDisplayString(formatFecha(v.fecha_creacion)), 1),
                  _createElementVNode("p", _hoisted_32, "Tipo: " + _toDisplayString(tipoDeModelo(v)?.tipo ?? 'Sin tipo'), 1),
                  (versionesConProceso.value.has(v.id_version!))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, " En proceso · " + _toDisplayString(etiquetaEstadoProceso(versionesEstadoProceso.value[v.id_version!])), 1))
                    : _createCommentVNode("", true),
                  (cardSeleccionada.value === v.id_version)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        (props.modoIndicadores)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_unref(auth).tienePermiso('indicadores.crear'))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "btn guardar",
                                    onClick: _withModifiers(($event: any) => (agregarIndicadoresVersion(v)), ["stop"])
                                  }, "Agregar Indicadores", 8, _hoisted_35))
                                : _createCommentVNode("", true),
                              (_unref(auth).tienePermiso('versiones.crear'))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: "btn guardar",
                                    onClick: _withModifiers(($event: any) => (abrirEditarVersion(v)), ["stop"])
                                  }, "Editar", 8, _hoisted_36))
                                : _createCommentVNode("", true),
                              (_unref(auth).tienePermiso('versiones.crear'))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 2,
                                    class: "btn guardar",
                                    onClick: _withModifiers(($event: any) => (clonarVersion(v)), ["stop"])
                                  }, "Clonar", 8, _hoisted_37))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true),
                        (props.modoCalificar)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (_unref(auth).tienePermiso('calificacion.calificar'))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "btn guardar",
                                    onClick: _withModifiers(($event: any) => (calificarInstrumentosVersion(v)), ["stop"])
                                  }, "Calificar Indicadores", 8, _hoisted_38))
                                : _createCommentVNode("", true),
                              _createElementVNode("button", {
                                class: "btn completar",
                                disabled: completandoEtapa.value,
                                onClick: _withModifiers(($event: any) => (completarEtapa(v)), ["stop"])
                              }, _toDisplayString(completandoEtapa.value ? 'Completando...' : 'Completar Calificación'), 9, _hoisted_39)
                            ], 64))
                          : _createCommentVNode("", true),
                        (props.modoEvidencias)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              (_unref(auth).tienePermiso('evidencias.subir'))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "btn guardar",
                                    onClick: _withModifiers(($event: any) => (subirEvidenciasVersion(v)), ["stop"])
                                  }, "Subir evidencias", 8, _hoisted_40))
                                : _createCommentVNode("", true),
                              _createElementVNode("button", {
                                class: "btn completar",
                                disabled: completandoEtapa.value,
                                onClick: _withModifiers(($event: any) => (completarEtapa(v)), ["stop"])
                              }, _toDisplayString(completandoEtapa.value ? 'Completando...' : 'Completar'), 9, _hoisted_41)
                            ], 64))
                          : _createCommentVNode("", true),
                        (props.modoAsignarEvaluadores)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              (_unref(auth).tienePermiso('procesos.asignar'))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "btn guardar",
                                    onClick: _withModifiers(($event: any) => (navegarEvaluacionExpertos(v, 'AsignarEvaluadores')), ["stop"])
                                  }, "Evaluadores", 8, _hoisted_42))
                                : _createCommentVNode("", true),
                              (_unref(auth).tienePermiso('calificacion.ver'))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: "btn guardar",
                                    onClick: _withModifiers(($event: any) => (navegarEvaluacionExpertos(v, 'ResultadosConsolidados')), ["stop"])
                                  }, "Resultados", 8, _hoisted_43))
                                : _createCommentVNode("", true),
                              (_unref(auth).tienePermiso('calificacion.ver'))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 2,
                                    class: "btn guardar",
                                    onClick: _withModifiers(($event: any) => (navegarEvaluacionExpertos(v, 'AuditoriaEvaluaciones')), ["stop"])
                                  }, "Auditoría", 8, _hoisted_44))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true),
                        (props.modoEvaluacionExpertos)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                              (_unref(auth).tienePermiso('expertos.gestionar'))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "btn guardar",
                                    onClick: _withModifiers(($event: any) => (navegarEvaluacionExpertos(v, 'EvaluacionExpertos')), ["stop"])
                                  }, "Evaluar Modelo", 8, _hoisted_45))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true),
                        (_unref(auth).tienePermiso('versiones.aprobar') && v.estado !== 'descontinuado')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 5,
                              class: "btn peligro",
                              disabled: descontinuando.value,
                              onClick: _withModifiers(($event: any) => (abrirConfirmarDescontinuarVersion(v)), ["stop"])
                            }, "Descontinuar", 8, _hoisted_46))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_28))
              }), 128))
        ]))
      : _createCommentVNode("", true),
    (!loading.value && totalPaginas.value > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
          _createElementVNode("button", {
            class: "btn-pag",
            disabled: paginaActual.value === 1,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (paginaActual.value--))
          }, "Anterior", 8, _hoisted_48),
          _createElementVNode("span", _hoisted_49, _toDisplayString(paginaActual.value) + " de " + _toDisplayString(totalPaginas.value), 1),
          _createElementVNode("button", {
            class: "btn-pag",
            disabled: paginaActual.value === totalPaginas.value,
            onClick: _cache[6] || (_cache[6] = ($event: any) => (paginaActual.value++))
          }, "Siguiente", 8, _hoisted_50)
        ]))
      : (!loading.value && error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
            _createElementVNode("p", null, "Error al cargar modelos: " + _toDisplayString(error.value), 1),
            _createElementVNode("button", {
              class: "btn guardar",
              onClick: cargar
            }, "Reintentar")
          ]))
        : (!loading.value && !(modoNormal.value ? modelosParaCardsNormal.value.length : versionesFiltradas.value.length))
          ? (_openBlock(), _createElementBlock("p", _hoisted_52, "No hay Modelos creados aún."))
          : _createCommentVNode("", true),
    _createVNode(MensajeFlotante, {
      visible: mensajeVisible.value,
      mensaje: mensajeTexto.value,
      tipo: mensajeTipo.value,
      onCerrar: _cache[7] || (_cache[7] = ($event: any) => (mensajeVisible.value = false))
    }, null, 8, ["visible", "mensaje", "tipo"]),
    _createVNode(VersionarModal, {
      visible: modalVersionarVisible.value,
      onConfirmar: confirmarVersionar,
      onCancelar: _cache[8] || (_cache[8] = ($event: any) => {modalVersionarVisible.value = false; versionParaVersionar.value = null; modeloParaVersionar.value = null})
    }, null, 8, ["visible"]),
    _createVNode(ClonarModeloModal, {
      visible: modalClonarVisible.value,
      idModelo: modalClonarIdModelo.value,
      idVersionOrigen: modalClonarIdVersionOrigen.value,
      onAceptar: confirmarClonarModelo,
      onCancelar: _cache[9] || (_cache[9] = ($event: any) => {modalClonarVisible.value = false; versionParaClonar.value = null; modeloParaClonar.value = null})
    }, null, 8, ["visible", "idModelo", "idVersionOrigen"]),
    (confirmarDescontinuarVisible.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 6,
          class: "ev-overlay",
          onClick: _withModifiers(cerrarConfirmarDescontinuar, ["self"])
        }, [
          _createElementVNode("div", _hoisted_53, [
            _cache[22] || (_cache[22] = _createElementVNode("h4", { class: "ev-titulo" }, "Confirmar acción", -1)),
            _cache[23] || (_cache[23] = _createElementVNode("p", { class: "dc-aviso" }, [
              _createTextVNode(" Esta acción es irreversible. Para confirmar, escribe "),
              _createElementVNode("strong", null, "descontinuar"),
              _createTextVNode(" en el campo y presiona Aceptar. ")
            ], -1)),
            (confirmarDescontinuarNombre.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_54, _toDisplayString(confirmarDescontinuarNombre.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_55, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((confirmarDescontinuarTexto).value = $event)),
                type: "text",
                class: "ev-input",
                placeholder: "Escribe: descontinuar",
                onKeyup: _withKeys(ejecutarDescontinuar, ["enter"])
              }, null, 544), [
                [_vModelText, confirmarDescontinuarTexto.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("button", {
                class: "btn salir",
                onClick: cerrarConfirmarDescontinuar
              }, "Cancelar"),
              _createElementVNode("button", {
                class: "btn guardar",
                disabled: descontinuando.value || confirmarDescontinuarTexto.value.trim().toLowerCase() !== 'descontinuar',
                onClick: ejecutarDescontinuar
              }, _toDisplayString(descontinuando.value ? 'Procesando...' : 'Aceptar'), 9, _hoisted_57)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (editarVersionVisible.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 7,
          class: "ev-overlay",
          onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (editarVersionVisible.value = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_58, [
            _cache[25] || (_cache[25] = _createElementVNode("h4", { class: "ev-titulo" }, "Editar nombre de versión", -1)),
            _createElementVNode("div", _hoisted_59, [
              _cache[24] || (_cache[24] = _createElementVNode("label", {
                class: "ev-label",
                for: "ev-input-nombre"
              }, "Nombre", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "ev-input-nombre",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((nombreEdicion).value = $event)),
                type: "text",
                class: "ev-input",
                placeholder: "Nombre de la versión",
                onKeyup: _withKeys(guardarEdicionVersion, ["enter"])
              }, null, 544), [
                [_vModelText, nombreEdicion.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("button", {
                class: "btn salir",
                disabled: guardandoEdicion.value,
                onClick: _cache[12] || (_cache[12] = ($event: any) => (editarVersionVisible.value = false))
              }, "Cancelar", 8, _hoisted_61),
              _createElementVNode("button", {
                class: "btn guardar",
                disabled: guardandoEdicion.value || !nombreEdicion.value.trim(),
                onClick: guardarEdicionVersion
              }, _toDisplayString(guardandoEdicion.value ? 'Guardando...' : 'Guardar'), 9, _hoisted_62)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})